<lms-breadcrumb [label]="'reports.' + report + '.label'"></lms-breadcrumb>
<div class="gl-reports">
  <ng-container [ngSwitch]="report">
    <ng-container *ngSwitchCase="'groups'">
      <gl-groups-report
        [report]="personalization"
        [filters]="filters"
        (save)="saveReport($event)"
        (download)="downloadReport($event)"
      ></gl-groups-report>
    </ng-container>
    <ng-container *ngSwitchCase="'licenses'">
      <gl-licenses-report
        [report]="personalization"
        [filters]="filters"
        [attr.reportType]="activeReportMode"
        (save)="saveReport($event)"
        (download)="downloadReport($event)"
      ></gl-licenses-report>
    </ng-container>
    <ng-container *ngSwitchCase="'students'">
      <gl-students-report
        [report]="personalization"
        [filters]="filters"
        (save)="saveReport($event)"
        (download)="downloadReport($event)"
      ></gl-students-report>
    </ng-container>
    <ng-container *ngSwitchCase="'surveys'">
      <gl-surveys-report
        [report]="personalization"
        [filters]="filters"
        (save)="saveReport($event)"
        [type]="reportType"
        (download)="downloadReport($event)"
      ></gl-surveys-report>
    </ng-container>
    <ng-container *ngSwitchCase="'events'">
      <gl-events-report
        [report]="personalization"
        [filters]="filters"
        (save)="saveReport($event)"
        (download)="downloadReport($event)"
      ></gl-events-report>
    </ng-container>
    <ng-container *ngSwitchCase="'activity'">
      <gl-activity-report
        [report]="personalization"
        [filters]="filters"
        (save)="saveReport($event)"
        (download)="downloadReport($event)"
      ></gl-activity-report>
    </ng-container>
  </ng-container>
</div>

<!--Actions buttons report-->
<div *ngIf="report == 'licenses'" class="gl-context-menu__position reports">
  <lms-button-actions>
    <div class="gl-context-menu__options">
      <span
        class="gl-context-menu__options--item"
        title="{{ 'reports.licenses.configReport' | translate }}"
        (click)="openConfigModal()"
      >
        {{ 'reports.licenses.configReport' | translate }}
      </span>
    </div>
  </lms-button-actions>
</div>
<!-- Reports modal config -->
<lms-modal #modalConfigReports size="normal">
  <div class="gl-popup__title gap-bottom">{{ 'reports.licenses.configTitle' | translate }}</div>
  <div class="gl-popup__text">
    {{ 'reports.licenses.configSubtitle' | translate }}
  </div>
  <div class="gl-popup__close" (click)="modalConfigReports.close()">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-popup__text">
    <gl-select
      [attr.disabled]="personalization ? true : null"
      [value]="selectedReportMode"
      [options]="reportModeOptions"
      (onChange)="selectedReportMode = $event.detail.value"
    ></gl-select>
  </div>
  <div class="gl-popup__buttons position-static">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalConfigReports.close()"></gl-button>
    <gl-button color-primary [text]="'actions.accept' | translate" (onClick)="changeReportType()"></gl-button>
  </div>
</lms-modal>
